import type { RendererProps } from "../core/element-registry"
import { useAtomDefaults } from "../contexts/atom-defaults-context"
import { ScrollArea } from "../components/ui/scroll-area"
import { ElementRenderer } from "./element-renderer"

export function ScrollAreaRenderer({ element }: RendererProps) {
  // Theme-v2 atom defaults feed the fallback chain:
  //   element.variant → atomDefaults.defaultVariant → shadcn 'default'.
  // default-theme.json matrix has availableVariants ['default'] and no
  // availableSizes — the renderer still surfaces data-size for parity with
  // sibling atom renderers.
  const atomDefaults = useAtomDefaults("scroll-area")
  const resolvedVariant = element.variant ?? atomDefaults.defaultVariant ?? "default"
  const resolvedSize = (element as { size?: string }).size
    ?? atomDefaults.defaultSize
    ?? "default"
  const rawOrientation = (element as unknown as { orientation?: unknown }).orientation
  const orientation = rawOrientation === "horizontal" || rawOrientation === "both"
    ? rawOrientation
    : "vertical"

  return (
    <ScrollArea
      className={element.className}
      data-testid={`scroll-area-${element.id}`}
      data-atom-type="scroll-area"
      data-variant={resolvedVariant}
      data-size={resolvedSize}
      data-orientation={orientation}
      orientation={orientation}
    >
      {element.children?.map((child) => (
        <ElementRenderer key={child.id} element={child} />
      ))}
    </ScrollArea>
  )
}
